import React from 'react';

import { useQuery } from '@tanstack/react-query';

import Layout from '../../containers/Layout';

import classes from './styles.module.css';
import TermsOfServiceService from '../../services/TermsOfServiceService';

export default function LenderTermsPage() {
  const { data: termsOfService } = useQuery({
    queryKey: ['terms_of_service'],
    queryFn: TermsOfServiceService.getTermsOfService,
  });

  return (
    <Layout noSidebar>
      <main className="grow">
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full">
          <div className="max-w-5xl mx-auto flex flex-col lg:flex-row lg:space-x-8 xl:space-x-16">
            <div
              className={classes.text}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: termsOfService?.content }}
            />
          </div>
        </div>
      </main>
    </Layout>
  );
}
